import { useMemo } from 'react'
import { useProcessStatuses } from './useProcessStatuses'

export function useProcessStatusOptions() {
    const { processStatuses } = useProcessStatuses()

    const processStatusOptions = useMemo(
        () =>
            processStatuses
                ?.map((ps) => ({
                    id: ps.id,
                    statusLabel: ps.statusLabel,
                    groupBy: ps.processStatusSummaryGroup?.label ?? 'No Group',
                }))
                .sort((a, b) => a.groupBy.localeCompare(b.groupBy)) ?? [],
        [processStatuses]
    )

    return { processStatusOptions }
}
